import * as yup from 'yup'

export const fieldNames = ['programStartDate']

export const validationSchema = yup.object().shape({
  programStartDate: yup
    .date()
    .nullable()
    .required('Program Start Date is required'),
})
